import React, { FC, ReactElement } from 'react';
import { useConditionalRendering } from 'src/hooks/useConditionalRendering';

interface Props {
  children: ReactElement | undefined | null;
  fieldName: string | undefined;
}

export const InputFieldConditionalRendering: FC<Props> = ({ children, fieldName }) => {
  const shouldRender = useConditionalRendering(fieldName);

  if (shouldRender) {
    return <>{children}</>;
  }

  return <></>;
};
